export type HddFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type HddFilterGroup = {
  id: string;
  label: string;
  options: HddFilterOption[];
};

export const hddFilterGroups: HddFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'seagate', label: 'Seagate', keywords: ['seagate'] },
      { value: 'wd', label: 'Western Digital', keywords: ['western digital', 'wd'] },
      { value: 'toshiba', label: 'Toshiba', keywords: ['toshiba'] },
      { value: 'samsung', label: 'Samsung', keywords: ['samsung'] },
      { value: 'hitachi', label: 'Hitachi', keywords: ['hitachi'] },
      { value: 'hgst', label: 'HGST', keywords: ['hgst'] },
      { value: 'maxtor', label: 'Maxtor', keywords: ['maxtor'] },
      { value: 'fujitsu', label: 'Fujitsu', keywords: ['fujitsu'] },
    ],
  },
  {
    id: 'capacity',
    label: 'Dung lượng',
    options: [
      { value: '500gb', label: '500GB', keywords: ['500gb'] },
      { value: '1tb', label: '1TB', keywords: ['1tb'] },
      { value: '2tb', label: '2TB', keywords: ['2tb'] },
      { value: '4tb', label: '4TB', keywords: ['4tb'] },
      { value: '6tb', label: '6TB', keywords: ['6tb'] },
      { value: '8tb', label: '8TB', keywords: ['8tb'] },
      { value: '10tb', label: '10TB+', keywords: ['10tb', '12tb', '14tb', '16tb'] },
    ],
  },
  {
    id: 'interface',
    label: 'Chuẩn giao tiếp',
    options: [
      { value: 'sata', label: 'SATA III', keywords: ['sata', 'sata iii'] },
      { value: 'sas', label: 'SAS', keywords: ['sas'] },
    ],
  },
  {
    id: 'size',
    label: 'Kích thước',
    options: [
      { value: '2-5', label: '2.5"', keywords: ['2.5', '2.5"'] },
      { value: '3-5', label: '3.5"', keywords: ['3.5', '3.5"'] },
    ],
  },
  {
    id: 'rpm',
    label: 'Tốc độ vòng quay (RPM)',
    options: [
      { value: '5400', label: '5400 RPM', keywords: ['5400'] },
      { value: '7200', label: '7200 RPM', keywords: ['7200'] },
      { value: '10000', label: '10000 RPM', keywords: ['10000'] },
    ],
  },
  {
    id: 'tech',
    label: 'Công nghệ',
    options: [
      { value: 'hybrid', label: 'Hybrid HDD', keywords: ['hybrid'] },
      { value: 'surveillance', label: 'Surveillance HDD', keywords: ['surveillance'] },
      { value: 'enterprise', label: 'Enterprise HDD', keywords: ['enterprise'] },
    ],
  },
];
